function parseNumberish(value) {
  if (value == null) return null;
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }
  if (typeof value === 'string') {
    const cleaned = value.trim();
    if (!cleaned) return null;
    let normalized = cleaned;
    if (cleaned.includes(',') && cleaned.includes('.')) {
      if (cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')) {
        normalized = cleaned.replace(/\./g, '').replace(',', '.');
      } else {
        normalized = cleaned.replace(/,/g, '');
      }
    } else if (cleaned.includes(',')) {
      normalized = cleaned.replace(',', '.');
    }
    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}

function parseQuantity(value) {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) return 1;
  return Math.floor(parsed);
}

export function getExtraPriceCents(extra) {
  if (!extra || typeof extra !== 'object') return 0;

  const centsCandidate = Number(extra.price_cents ?? extra.preco_centavos ?? NaN);
  if (Number.isFinite(centsCandidate)) {
    return Math.max(0, Math.round(centsCandidate));
  }

  const raw = parseNumberish(extra.price ?? extra.preco);
  if (!Number.isFinite(raw)) return 0;
  return Math.max(0, Math.round(raw * 100));
}

export function getExtraPriceReais(extra) {
  return getExtraPriceCents(extra) / 100;
}

export function getSelectedExtrasUnitTotalReais(selectedExtras) {
  if (!Array.isArray(selectedExtras)) return 0;
  return selectedExtras.reduce((sum, extra) => {
    const cents = getExtraPriceCents(extra);
    const quantity = parseQuantity(extra?.quantity);
    return sum + ((cents / 100) * quantity);
  }, 0);
}
